import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { GetProjectByCode, GetProjects, InitProjectState, Pagination } from './project.state';

export const projectGuard: CanActivateFn = (next: ActivatedRouteSnapshot): boolean | UrlTree => {
    const store = inject(Store);
    let pagination: Pagination = {};
    store.dispatch([new InitProjectState({}), new GetProjects({ pagination })]);
    return true;
};

export const projectDetailGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): boolean | UrlTree => {
    const store = inject(Store);
    let code = next.params['code'];
    store.dispatch(new GetProjectByCode({ code }));
    return true;
};
